import { useEffect, useState } from "react";
import { onAuthStateChanged, type User } from "firebase/auth";
import { auth, isAllowedUser } from "../lib/firebase";

export interface AuthState {
  loading: boolean;
  user: User | null;
  allowed: boolean;
}

export function useAuth(): AuthState {
  const [state, setState] = useState<AuthState>({
    loading: true,
    user: null,
    allowed: false,
  });

  useEffect(() => {
    return onAuthStateChanged(auth, (user) => {
      setState({ loading: false, user, allowed: isAllowedUser(user) });
    });
  }, []);

  return state;
}
